import React from 'react'
import Header from '../Components/Header'
import { Container, IconButton } from '@mui/material'
import Footer from '../Components/Footer'
import { ArrowBack, ArrowForward, Search, Share } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import TopHeader from '../Components/TopHeader'
import TitrePage from './TitrePage'
import Reveal from '../Components/ui/Reveal'
import { Images } from '../Data/Images'
import { useNavigate } from 'react-router-dom'
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TelegramIcon, TelegramShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share'

interface Props { }

function Articles(props: Props) {
    const translation = useTranslation();
    const t = translation.t;
    const i18n = translation.i18n;
    const navigate = useNavigate()
    const [articles, setArticles] = React.useState<any>([])
    const [selectedArticle, setSelectedArticle] = React.useState<any>(null)
    const [allArticles, setAllArticles] = React.useState<any>([])
    const [pageLoad, setPageLoad] = React.useState<boolean>(true)

    if (pageLoad) {
        var ArticlesData =
            [
            {
            image: "https://dyma.fr/blog/content/images/size/w960/2024/08/docker1200x628.webp",
            title: "Déploiement d'applications avec Docker|Deploying Applications with Docker",
            description: "Un guide pour containeriser et déployer vos applications en utilisant Docker.|A guide to containerizing and deploying your applications using Docker.",
            content: `<p>Docker est une plateforme de conteneurisation qui permet de créer, déployer et exécuter des applications dans des conteneurs. Les conteneurs sont légers et portables, ce qui facilite le déploiement des applications dans différents environnements.</p>
              <p>Pour commencer avec Docker, vous devez l'installer et créer un fichier Dockerfile :</p>
              <pre><code># Utiliser une image de base
        FROM node:14

        # Définir le répertoire de travail
        WORKDIR /app

        # Copier les fichiers package.json et package-lock.json
        COPY package*.json ./

        # Installer les dépendances
        RUN npm install

        # Copier le reste des fichiers de l'application
        COPY . .

        # Exposer le port de l'application
        EXPOSE 3000

        # Démarrer l'application
        CMD ["npm", "start"]</code></pre>
              <p>Vous pouvez ensuite construire et exécuter l'image Docker :</p>
              <pre><code>docker build -t my-app .
        docker run -p 3000:3000 my-app</code></pre>|<p>Docker is a containerization platform that allows you to build, deploy, and run applications in containers. Containers are lightweight and portable, making it easy to deploy applications in different environments.</p>
              <p>To get started with Docker, you need to install it and create a Dockerfile:</p>
              <pre><code># Use a base image
        FROM node:14

        # Set the working directory
        WORKDIR /app

        # Copy package.json and package-lock.json
        COPY package*.json ./

        # Install dependencies
        RUN npm install

        # Copy the rest of the application files
        COPY . .

        # Expose the application port
        EXPOSE 3000

        # Start the application
        CMD ["npm", "start"]</code></pre>
              <p>You can then build and run the Docker image:</p>
              <pre><code>docker build -t my-app .
        docker run -p 3000:3000 my-app</code></pre>`
            },
            {
            image: "https://smartstore.com/media/6282/content/ASPNET-Core-ASPNET-MVC-1536px.webp?size=1024",
            title: "Connaissance de ASP.NET Entity Framework|State Management with ASP.NET Entity Framework",
            description: "Apprenez à gérer l'état dans vos applications ASP.NET en utilisant Entity Framework.|Learn how to manage state in your ASP.NET applications using Entity Framework.",
            content: `<p>Entity Framework est un ORM (Object-Relational Mapper) pour .NET qui permet aux développeurs de travailler avec des bases de données en utilisant des objets .NET. Il élimine la nécessité d'écrire la plupart du code d'accès aux données que les développeurs écrivent généralement.</p>
              <p>Pour commencer avec Entity Framework, vous devez installer les packages nécessaires :</p>
              <pre><code>Install-Package EntityFramework</code></pre>
              <p>Voici un exemple de configuration d'Entity Framework avec un simple modèle de données :</p>
              <pre><code>using System;
        using System.Data.Entity;

        public class BloggingContext : DbContext
        {
        public DbSet<Blog> Blogs { get; set; }
        public DbSet<Post> Posts { get; set; }
        }

        public class Blog
        {
        public int BlogId { get; set; }
        public string Name { get; set; }
        public string Url { get; set; }
        }

        public class Post
        {
        public int PostId { get; set; }
        public string Title { get; set; }
        public string Content { get; set; }
        public int BlogId { get; set; }
        public Blog Blog { get; set; }
        }</code></pre>
              <p>Pour interagir avec la base de données, vous pouvez utiliser LINQ pour effectuer des requêtes :</p>
              <pre><code>using (var db = new BloggingContext())
        {
        var blog = new Blog { Name = "ADO.NET Blog", Url = "http://blogs.msdn.com/adonet" };
        db.Blogs.Add(blog);
        db.SaveChanges();

        var query = from b in db.Blogs
            orderby b.Name
            select b;

        foreach (var item in query)
        {
            Console.WriteLine(item.Name);
        }
        }</code></pre>|<p>Entity Framework is an ORM (Object-Relational Mapper) for .NET that enables developers to work with databases using .NET objects. It eliminates the need for most of the data-access code that developers usually need to write.</p>
              <p>To get started with Entity Framework, you need to install the necessary packages:</p>
              <pre><code>Install-Package EntityFramework</code></pre>
              <p>Here is an example of setting up Entity Framework with a simple data model:</p>
              <pre><code>using System;
        using System.Data.Entity;

        public class BloggingContext : DbContext
        {
        public DbSet<Blog> Blogs { get; set; }
        public DbSet<Post> Posts { get; set; }
        }

        public class Blog
        {
        public int BlogId { get; set; }
        public string Name { get; set; }
        public string Url { get; set; }
        }

        public class Post
        {
        public int PostId { get; set; }
        public string Title { get; set; }
        public string Content { get; set; }
        public int BlogId { get; set; }
        public Blog Blog { get; set; }
        }</code></pre>
              <p>To interact with the database, you can use LINQ to perform queries:</p>
              <pre><code>using (var db = new BloggingContext())
        {
        var blog = new Blog { Name = "ADO.NET Blog", Url = "http://blogs.msdn.com/adonet" };
        db.Blogs.Add(blog);
        db.SaveChanges();

        var query = from b in db.Blogs
            orderby b.Name
            select b;

        foreach (var item in query)
        {
            Console.WriteLine(item.Name);
        }
        }</code></pre>`
            },
            {
            image: "https://www.jeveuxetredatascientist.fr/wp-content/uploads/2021/08/Microsoft-Azure.jpeg",
            title: "Introduction à Azure|Introduction to Azure",
            description: "Une introduction à Microsoft Azure, ses services et comment les utiliser.|An introduction to Microsoft Azure, its services, and how to use them.",
            content: `<p>Microsoft Azure est une plateforme de cloud computing qui offre une large gamme de services pour le développement, le déploiement et la gestion d'applications. Azure prend en charge divers langages de programmation, outils et frameworks.</p>
              <p>Pour commencer avec Azure, vous devez créer un compte Azure et installer l'interface de ligne de commande Azure (Azure CLI) :</p>
              <pre><code>az login</code></pre>
              <p>Voici un exemple de création d'une machine virtuelle (VM) sur Azure :</p>
              <pre><code>az vm create \
          --resource-group myResourceGroup \
          --name myVM \
          --image UbuntuLTS \
          --admin-username azureuser \
          --generate-ssh-keys</code></pre>
              <p>Vous pouvez également utiliser Azure Portal pour gérer vos ressources Azure via une interface graphique :</p>
              <pre><code>https://portal.azure.com</code></pre>|<p>Microsoft Azure is a cloud computing platform that offers a wide range of services for building, deploying, and managing applications. Azure supports various programming languages, tools, and frameworks.</p>
              <p>To get started with Azure, you need to create an Azure account and install the Azure Command-Line Interface (Azure CLI):</p>
              <pre><code>az login</code></pre>
              <p>Here is an example of creating a Virtual Machine (VM) on Azure:</p>
              <pre><code>az vm create \
          --resource-group myResourceGroup \
          --name myVM \
          --image UbuntuLTS \
          --admin-username azureuser \
          --generate-ssh-keys</code></pre>
              <p>You can also use the Azure Portal to manage your Azure resources via a graphical interface:</p>
              <pre><code>https://portal.azure.com</code></pre>`
            },
            {
            image: "https://www.brightwork.com/wp-content/uploads/Scrum-vs-Kanban-1-scaled.webp",
            title: "Introduction au Scrum|Introduction to Scrum",
            description: "Une introduction à la méthodologie Scrum, ses rôles, événements et artefacts.|An introduction to the Scrum methodology, its roles, events, and artifacts.",
            content: `<p>Scrum est un cadre de travail agile pour le développement de produits complexes. Il se compose de rôles, d'événements et d'artefacts spécifiques qui aident les équipes à travailler ensemble de manière efficace.</p>
              <p>Les principaux rôles dans Scrum sont :</p>
              <ul>
            <li>Product Owner</li>
            <li>Scrum Master</li>
            <li>Development Team</li>
              </ul>
              <p>Les principaux événements dans Scrum sont :</p>
              <ul>
            <li>Sprint Planning</li>
            <li>Daily Scrum</li>
            <li>Sprint Review</li>
            <li>Sprint Retrospective</li>
              </ul>
              <p>Les principaux artefacts dans Scrum sont :</p>
              <ul>
            <li>Product Backlog</li>
            <li>Sprint Backlog</li>
            <li>Increment</li>
              </ul>|<p>Scrum is an agile framework for developing complex products. It consists of specific roles, events, and artifacts that help teams work together effectively.</p>
              <p>The main roles in Scrum are:</p>
              <ul>
            <li>Product Owner</li>
            <li>Scrum Master</li>
            <li>Development Team</li>
              </ul>
              <p>The main events in Scrum are:</p>
              <ul>
            <li>Sprint Planning</li>
            <li>Daily Scrum</li>
            <li>Sprint Review</li>
            <li>Sprint Retrospective</li>
              </ul>
              <p>The main artifacts in Scrum are:</p>
              <ul>
            <li>Product Backlog</li>
            <li>Sprint Backlog</li>
            <li>Increment</li>
              </ul>`
            }
            ]
        setArticles(ArticlesData)
        setAllArticles(ArticlesData)
        setPageLoad(false)

        // alert(window.location.href.split('/')[window.location.href.split('/').length - 1])
        const articleTitle = window.location.href.split('/')[window.location.href.split('/').length - 1];
        const foundArticle = ArticlesData.find((article: any) =>
            (`${article.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`).includes(articleTitle)
        );
        if (foundArticle) {
            setSelectedArticle(foundArticle);
        }

    }
    const lang = i18n.language === 'fr' ? 0 : 1
    const pick = (value: string) => value.split('|')[lang]

    const hideBroken = (e: React.SyntheticEvent<HTMLImageElement>) => { e.currentTarget.style.visibility = 'hidden' }

    function handleChange(article: any) {
        navigate(`/articles/${article.title.split('|')[0].toLowerCase().replace(/[^a-z0-9]+/g, '-')}`)
        setSelectedArticle(article)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    function backToList() {
        navigate('/articles')
        setSelectedArticle(null)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <div className="ibg-page">
            <TopHeader />
            <Header />
            <TitrePage hiddeTitle={selectedArticle === null ? undefined : true} image={Images.pageHeroes.articles.src} titre={selectedArticle === null ? 'titrePage.Articles.titre' : pick(selectedArticle.title)} lien='Articles' pageDescription={selectedArticle === null ? 'titrePage.Articles.description' : pick(selectedArticle.description)} keyWords={'titrePage.Articles.keywords'} />

            {selectedArticle === null ? (
                <section className="ibg-section">
                    <Container maxWidth="lg">
                        <div className="ibg-toolbar">
                            <span className="ibg-eyebrow">{t("titrePage.Articles.titre")}</span>
                            <label className="ibg-input">
                                <Search fontSize="small" />
                                <input
                                    type="search"
                                    placeholder={t('rechercherArticle')}
                                    onChange={(e) => {
                                        const query = e.target.value.toLowerCase();
                                        var data = allArticles.filter((article: any) =>
                                            article.title.toLowerCase().includes(query) ||
                                            article.description.toLowerCase().includes(query) ||
                                            article.content.toLowerCase().includes(query)
                                        );
                                        setArticles(data)
                                    }}
                                />
                            </label>
                        </div>
                        {articles.length > 0 ?
                            <div className="ibg-grid ibg-grid--3">
                                {articles.map((article: any, index: number) => (
                                    <Reveal key={article.title} delay={index * 0.06}>
                                        <article className="ibg-product" onClick={() => handleChange(article)}>
                                            <div className="ibg-image ibg-image--rounded" style={{ aspectRatio: '16 / 10' }}>
                                                <div className="ibg-image__placeholder" />
                                                <img src={article.image} alt={pick(article.title)} loading="lazy" onError={hideBroken} />
                                            </div>
                                            <div className="ibg-product__body">
                                                <h3 className="ibg-h4">{pick(article.title)}</h3>
                                                <p className="ibg-small">{pick(article.description)}</p>
                                                <span className="ibg-tile__link">{t("Pages.readArticle")} <ArrowForward fontSize="small" /></span>
                                            </div>
                                        </article>
                                    </Reveal>
                                ))}
                            </div>
                            : <p className="ibg-empty">{t("Pages.noArticle")}</p>}
                    </Container>
                </section>
            ) : (
                <article id="article" className="ibg-section ibg-article">
                    <Container maxWidth="md">
                        <button className="ibg-link ibg-link--back" onClick={backToList}>
                            <ArrowBack fontSize="small" /> {t("Pages.backToArticles")}
                        </button>
                        <Reveal>
                            <span className="ibg-eyebrow">{t("titrePage.Articles.titre")}</span>
                            <h1 className="ibg-article__title">{pick(selectedArticle.title)}</h1>
                            <p className="ibg-lead">{pick(selectedArticle.description)}</p>
                        </Reveal>
                        <Reveal delay={0.1} className="ibg-article__cover">
                            <div className="ibg-image__placeholder" />
                            <img src={selectedArticle.image} alt={pick(selectedArticle.title)} onError={hideBroken} />
                        </Reveal>
                        <div className="ibg-prose" dangerouslySetInnerHTML={{ __html: pick(selectedArticle.content) }} />
                        <div className="ibg-share">
                            <span>{t("Pages.share")}</span>
                            <div className="ibg-share__buttons">
                                {
                                    navigator.share && (
                                        <IconButton
                                            aria-label={t("Pages.share")}
                                            onClick={() => {
                                                if (navigator.share) {
                                                    navigator.share({
                                                        title: pick(selectedArticle.title),
                                                        text: pick(selectedArticle.description),
                                                        url: window.location.href,
                                                    }).catch(console.error);
                                                } else {
                                                    alert("Le partage natif n'est pas supporté sur cet appareil.");
                                                }
                                            }}
                                        >
                                            <Share fontSize="small" />
                                        </IconButton>
                                    )
                                }
                                <FacebookShareButton url={window.location.href} title={pick(selectedArticle.title)}>
                                    <FacebookIcon size={40} round bgStyle={{ fill: 'transparent' }} iconFillColor="currentColor" />
                                </FacebookShareButton>
                                <TwitterShareButton url={window.location.href} title={pick(selectedArticle.title)}>
                                    <TwitterIcon size={40} round bgStyle={{ fill: 'transparent' }} iconFillColor="currentColor" />
                                </TwitterShareButton>
                                <LinkedinShareButton url={window.location.href} title={pick(selectedArticle.title)} summary={pick(selectedArticle.description)}>
                                    <LinkedinIcon size={40} round bgStyle={{ fill: 'transparent' }} iconFillColor="currentColor" />
                                </LinkedinShareButton>
                                <WhatsappShareButton url={window.location.href} title={pick(selectedArticle.title)}>
                                    <WhatsappIcon size={40} round bgStyle={{ fill: 'transparent' }} iconFillColor="currentColor" />
                                </WhatsappShareButton>
                                <TelegramShareButton url={window.location.href} title={pick(selectedArticle.title)}>
                                    <TelegramIcon size={40} round bgStyle={{ fill: 'transparent' }} iconFillColor="currentColor" />
                                </TelegramShareButton>

                                {/* 
                                <IconButton
                                    size='small'
                                    style={{ border: "1px rgba(0, 0, 0, .2) solid" }}
                                    onClick={() => { navigator.clipboard.writeText(window.location.href); alert("Lien de l'article copié!!!") }}
                                >
                                    <CopyAll color='primary' />
                                </IconButton> */}
                            </div>
                        </div>
                    </Container>
                </article>
            )}
            <Footer />
        </div>
    )
}

export default Articles
